import { useMutation } from '@tanstack/react-query';
import { finalizeSplitPayments } from '../../services/payments';

type Props = {
  onSuccess?: (data: Awaited<ReturnType<typeof finalizeSplitPayments>>) => void;
  onError?: (error: Error) => void;
};

function useFinalizeSplitPayments({ onSuccess, onError }: Props = {}) {
  return useMutation({
    mutationFn: ({ splitPaymentsGroupId }: { splitPaymentsGroupId: string }) =>
      finalizeSplitPayments(splitPaymentsGroupId),
    onSuccess,
    onError,
  });
}

export default useFinalizeSplitPayments;
